import { BirthdayEventType } from '@api';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';

type BdayHoverCardPropsType = {
  birthday: BirthdayEventType;
};

export const BdayHoverCard: React.FC<BdayHoverCardPropsType> = ({
  birthday,
}) => {
  return (
    <Stack align="center">
      <Text fw={700}>{birthday.person.name}</Text>
      <Group gap={2}>
        <FontAwesomeIcon icon={faCalendar} size="sm" />
        <Text>
          {birthday.birthdate.year
            ? dayjs()
                .year(birthday.birthdate.year)
                .month((birthday.birthdate.month ?? 1) - 1)
                .date(birthday.birthdate.day ?? 1)
                .format('DD.MM.YYYY')
            : dayjs()
                .month((birthday.birthdate.month ?? 1) - 1)
                .date(birthday.birthdate.day ?? 1)
                .format('DD.MM.')}
        </Text>
      </Group>
    </Stack>
  );
};
